import styled from 'styled-components'

export const ModalTemplateTitle = styled.h1`
	font-weight: 600;
	font-size: 25px;
	color: ${({theme}) => theme.colors.primary};
	margin-top: 25px;
	margin-bottom: 0px;
	line-height: 42px;
	letter-spacing: -0.03em;
`

export const ModalTemplateIcon = styled.img`
	width: 94px;
	height: 94px;
	margin: 0 auto;
`